<h2 mat-dialog-title>Confirmación</h2>
<div class="mat-divider-container">
  <mat-divider></mat-divider>
</div>
<mat-dialog-content class="mat-typography">
  <h5>¿Desea realizar su pedido?</h5>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <a mat-raised-button color="accent" mat-dialog-close>Cancelar</a>
  <a mat-raised-button color="accent" [mat-dialog-close]="true" >Aceptar</a>
</mat-dialog-actions>

